import React from "react";
import { Navigate } from "react-router-dom";

//Dashboard
import DashboardEcommerce from "../pages/Dashboard";

// //Tables
import BasicTables from '../pages/Tables/BasicTables/BasicTables';
// import ListTables from '../pages/Tables/ListTables/ListTables';
import ReactTable from "../pages/Tables/ReactTables";

// //Icon pages
import RemixIcons from "../pages/Icons/RemixIcons/RemixIcons";
import BoxIcons from "../pages/Icons/BoxIcons/BoxIcons";
import MaterialDesign from "../pages/Icons/MaterialDesign/MaterialDesign";
import FeatherIcons from "../pages/Icons/FeatherIcons/FeatherIcons";
import LineAwesomeIcons from "../pages/Icons/LineAwesomeIcons/LineAwesomeIcons";
import CryptoIcons from "../pages/Icons/CryptoIcons/CryptoIcons";

// //login
import Login from "../pages/Authentication/Login";
import Logout from "../pages/Authentication/Logout";
// import ZoneLayout from "../pages/zonelayout"

// // User Profile
import UserProfile from "../pages/Authentication/user-profile";

import UserManagement from "../pages/setting/usersetting"
import ProfileSettings from "../pages/setting/profilesetting"

import EmployeeMaster from "pages/Employee/employeemaster";
import CreateEmployee from "pages/Employee/createemployee";
import EditEmployee from "pages/Employee/editonboardemployee";
import AssignEmployee from "pages/Employee/employeetypeassign";
import DesignationMaster from "pages/master/designationmaster";
import UnitMaster from "pages/master/unitmaster";
import CompanySettings from "pages/setting/companysetting";
import Attendance from "pages/Attendance/attendance";
import MonthlySalary from "pages/Attendance/MonthlySalary";
import SundaySalary from "pages/Attendance/SundaySalary";
import OTSalary from "pages/Attendance/OTSalary";
import HolidayMaster from "pages/setting/holidaymaster";
import EPFESIReport from "pages/Report/esireport";
import BankMaster from "pages/master/bankmaster";
import OfficeLocationMaster from "pages/master/officelocationmaster";
import SiteLocationMaster from "pages/master/sitelocationmaster";
import LeaveRequestMaster from "pages/Attendance/leaverequest";
import Logpage from "pages/debug/log";
import LeaveTypeMaster from "pages/master/leavetypemaster";
import TodayAttendance from "pages/Attendance/todayattendance";
import EpfPercentage from "pages/setting/epfsetting";
import LeavePolicy from "pages/setting/leavepolicy";
import EmployeeLeavePolicy from "pages/Employee/employeeleavepolicy";
import LossOfPay from "pages/Attendance/lossofpay";

const authProtectedRoutes = [
  { path: "/dashboard", component: <DashboardEcommerce /> },
  { path: "/index", component: <DashboardEcommerce /> },
  // //Tables
  { path: "/tables-basic", component: <BasicTables /> },
  { path: "/tables-react", component: <ReactTable /> },

  // //Icons
  { path: "/icons-remix", component: <RemixIcons /> },
  { path: "/icons-boxicons", component: <BoxIcons /> },
  { path: "/icons-materialdesign", component: <MaterialDesign /> },
  { path: "/icons-feather", component: <FeatherIcons /> },
  { path: "/icons-lineawesome", component: <LineAwesomeIcons /> },
  { path: "/icons-crypto", component: <CryptoIcons /> },

  //User Profile
  { path: "/profile", component: <UserProfile /> },
  { path: "/employees", component: <EmployeeMaster /> },
  { path: "/create-employee", component: <CreateEmployee /> },
  { path: "/employee-leave-policy", component: <EmployeeLeavePolicy /> },
  { path: "/edit-employee/:id", component: <EditEmployee /> },
  { path: "/employees/:id/type-assignment", component: <AssignEmployee /> },
  { path: "/designation-master", component: <DesignationMaster /> },
  { path: "/unit-master", component: <UnitMaster /> },
  { path: "/company-setting", component: <CompanySettings /> },
  { path: "/profile-setting", component: <ProfileSettings /> },
  { path: "/attendance", component: <Attendance mode="standard" /> },
  { path: "/today-attendance", component: <TodayAttendance /> },
  { path: "/leaverequest", component: <LeaveRequestMaster /> },
  { path: "/attendance-report", component: <Attendance mode="ot" /> },
  { path: "/attendance-summary", component: <Attendance mode="sunday" /> },
  { path: "/monthly-salary", component: <MonthlySalary /> },
  { path: "/sunday-salary", component: <SundaySalary /> },
  { path: "/ot-salary", component: <OTSalary /> },
  { path: "/holiday-settings", component: <HolidayMaster /> },
  { path: "/loss-of-pay", component: <LossOfPay /> },
  { path: "/logs", component: <Logpage /> },

  // Settings 
  { path: "/user-setting", component: <UserManagement /> },
  { path: "/profile-setting", component: <ProfileSettings /> },
  { path: "/epf-esi", component: <EPFESIReport /> },
  { path: "/bank-master", component: <BankMaster /> },
  { path: "/officelocation-master", component: <OfficeLocationMaster /> },
  { path: "/sitelocation-master", component: <SiteLocationMaster /> },
  { path: '/leave-types', component: <LeaveTypeMaster /> },
  { path: '/epf-percentage', component: <EpfPercentage /> },
  { path: '/leave-policies', component: <LeavePolicy /> },
  // this route should be at the end of all other routes
  // eslint-disable-next-line react/display-name
  {
    path: "/",
    exact: true,
    component: <Navigate to="/dashboard" />,
  },
  { path: "*", component: <Navigate to="/dashboard" /> },
];

const publicRoutes = [
  // Authentication Page
  { path: "/logout", component: <Logout /> },
  { path: "/login", component: <Login /> },
  // { path: "/layout", component: <ZoneLayout /> },
];

export { authProtectedRoutes, publicRoutes };